// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__1__lQ","legacyBtn":"MutateMid_legacyBtn__18kds"};